"use strict";

require("core-js/modules/es.reflect.construct.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrayFields = exports["default"] = void 0;

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.date.to-string.js");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _components = require("./components");

var _reduxForm = require("redux-form");

var _react = _interopRequireWildcard(require("react"));

var _responsiveTable = require("./components/responsiveTable");

var _validations = require("./validations");

var _propTypes = require("prop-types");

var _lodash = _interopRequireDefault(require("lodash"));

var _utils = require("./components/utils");

var _fieldsLegacyOld = require("./fieldsLegacyOld");

var _excluded = ["components", "interface", "inputs", "label", "smallLabel", "description", "options", "question_description", "title", "labelStyle", "inputStyle", "config", "validations", "fieldSpacing", "normalize", "format", "parse", "collapseable", "nowDate"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FieldsArray = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(FieldsArray, _PureComponent);

  var _super = _createSuper(FieldsArray);

  function FieldsArray() {
    (0, _classCallCheck2["default"])(this, FieldsArray);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(FieldsArray, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          components = _this$props.components,
          intf = _this$props["interface"],
          _this$props$inputs = _this$props.inputs,
          inputs = _this$props$inputs === void 0 ? [] : _this$props$inputs,
          label = _this$props.label,
          smallLabel = _this$props.smallLabel,
          description = _this$props.description,
          options = _this$props.options,
          question_description = _this$props.question_description,
          title = _this$props.title,
          labelStyle = _this$props.labelStyle,
          inputStyle = _this$props.inputStyle,
          _this$props$config = _this$props.config,
          config = _this$props$config === void 0 ? {} : _this$props$config,
          validations = _this$props.validations,
          fieldSpacing = _this$props.fieldSpacing,
          normalize = _this$props.normalize,
          format = _this$props.format,
          parse = _this$props.parse,
          collapseable = _this$props.collapseable,
          nowDate = _this$props.nowDate,
          props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      config.disabled = this.props.disabled;

      var _generateCommonPassed = (0, _fieldsLegacyOld.generateCommonPassedProps)(this.props),
          listOfValidations = _generateCommonPassed.listOfValidations,
          wrapperContent = _generateCommonPassed.wrapperContent,
          fieldName = _generateCommonPassed.fieldName;

      listOfValidations = props.required ? [].concat((0, _toConsumableArray2["default"])(listOfValidations), [_validations.noEmptyArray]) : listOfValidations;

      switch (intf) {
        case "tabular":
        case "tabularlist":
          var isTabular = intf === "tabular";
          var firstInputGroup = inputs[0];
          var TabularSpan = (0, _utils.calculateTabularSpan)(firstInputGroup);
          var TableContent = isTabular ? (0, _components.RenderTabularArray)(_objectSpread(_objectSpread({}, props), {}, {
            nowDate: nowDate,
            name: fieldName,
            fields: inputs,
            config: _objectSpread(_objectSpread({}, props), {}, {
              component: intf,
              colspan: TabularSpan,
              key: fieldName
            })
          })) : /*#__PURE__*/_react["default"].createElement(_reduxForm.FieldArray, (0, _extends2["default"])({}, props, {
            validate: listOfValidations,
            name: fieldName,
            items: inputs[0],
            nowDate: nowDate,
            component: _components.TabularList,
            config: _objectSpread(_objectSpread({}, props), {}, {
              colspan: TabularSpan,
              component: intf
            })
          }));

          var RangeLabelContent = (!_lodash["default"].isEmpty(this.props.min_label) || !_lodash["default"].isEmpty(this.props.max_label)) && /*#__PURE__*/_react["default"].createElement(_components.RangeLabel, {
            max_label: this.props.max_label,
            min_label: this.props.min_label
          });

          return /*#__PURE__*/_react["default"].createElement(_components.FieldWrapper, wrapperContent, RangeLabelContent, /*#__PURE__*/_react["default"].createElement(_responsiveTable.Table, null, /*#__PURE__*/_react["default"].createElement(_responsiveTable.Thead, null, /*#__PURE__*/_react["default"].createElement(_responsiveTable.Tr, null, (0, _components.tabularHeading)(firstInputGroup, !isTabular))), TableContent));

        case "array":
          return /*#__PURE__*/_react["default"].createElement(_components.FieldWrapper, wrapperContent, /*#__PURE__*/_react["default"].createElement(_reduxForm.FieldArray, (0, _extends2["default"])({}, props, {
            components: components,
            validate: listOfValidations,
            name: fieldName,
            component: _components.RenderArray,
            nowDate: nowDate,
            config: props
          })));

        case "flatarray":
          return /*#__PURE__*/_react["default"].createElement(_components.FieldWrapper, wrapperContent, /*#__PURE__*/_react["default"].createElement(_reduxForm.FieldArray, (0, _extends2["default"])({}, this.props, {
            components: components,
            validate: listOfValidations,
            name: fieldName,
            inputStyle: inputStyle,
            labelStyle: labelStyle,
            label: label,
            component: _components.RenderFlatArray,
            nowDate: nowDate,
            config: props
          })));

        default:
          console.warn("Field type ".concat(intf, " \"").concat(label, "\" is not available"));
          return null;
      }
    }
  }]);
  return FieldsArray;
}(_react.PureComponent);

FieldsArray.defaultProps = {
  nowDate: new Date(),
  disabled: false
};
FieldsArray.propTypes = {
  "interface": (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, _propTypes.element]).isRequired,
  nowDate: _propTypes.object
};
var _default = FieldsArray;
exports["default"] = _default;
var ArrayFields = ['tabular', 'tabularlist', 'array', 'flatarray'];
exports.ArrayFields = ArrayFields;